// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterFrontImage_root__1oY4Y","title":"AfterFrontImage_title__2YNAf"};